import styled from "styled-components";

export const Container = styled.div`
	width: 40%;
	padding: 20px;
	display: flex;
	margin: 50px;
	border-radius: 10px;
	flex-direction: column;
	gap: 10px;
	background-color: #ffffff;

	@media (max-width: 768px){
        width: 100%;
	}
`;

export const FileElement = styled.input``;

export const Label = styled.label`
	margin-bottom: 5px;
	color: #666;
	font-size: 12px;
	font-weight: 400;
`;

export const GroupElement = styled.div`
	display: flex;
	flex-direction: column;
`;

export const PrimaryButton = styled.button`
	padding: 10px 15px;
	border-radius: 4px;
	background: linear-gradient(180deg, #ff8f4d 0%, #f26f21 100%);
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	color: #ffffff;
	font-weight: 700;
	font-size: 16px;
`;

export const SecondaryButton = styled.button`
	padding: 10px 15px;
	margin-right: 10px;
	border-radius: 8px;
	background: #fff;
	box-shadow: 0px 0px 8px 0px rgba(101, 34, 120, 0.2);
	color: #333333;
	font-weight: 700;
	font-size: 16px;
`;

export const Preview = styled.div``;

export const Image = styled.img``;
